<template>
  <div>
    <transition name="slide">
      <div class="notification fixed"  v-if="myShow == true">
        <div class="delete" v-if="myOptions.autoClose == false" @click="close()"></div>
        <div class="content">
          {{myOptions.content}}
          <span class="action" v-if="myOptions.action" @click="action()">{{myOptions.action}}</span>
        </div>
      </div>
    </transition>
    <div class="countdown" v-if="myShow && myOptions.autoClose && myOptions.countdownBar" :style="setTime" :class="barControl"></div>
  </div>
</template>

<script>
export default {
  name: 'Notification',
  data () {
    return {
      timers: [],
      barControl: '',
      myOptions: this.options,
      myShow: this.show
    }
  },
  props: {
    'options': {
      type: Object,
      default: {}
    },
    'show': {
      type: Boolean,
      default: false
    }
  },
  computed: {
    setTime () {
      return {
        transition: `all ${(this.myOptions.showTime / 1000) || 3}s linear`
      }
    }
  },
  methods: {
    countdown () {
      if (this.myOptions.autoClose) {
        if (this.myOptions.countdownBar) {
          setTimeout(() => {
            this.barControl = 'count-leave'
          }, 10)
        }
        const t = setTimeout(() => {
          this.close()
        }, this.myOptions.showTime || 3000)
        this.timers.push(t)
      }
    },
    close () {
      this.$emit('close') // should to emit to change parent components status
      this.myOptions = {}
    },
    action () {
      this[this.myOptions.action]()
    },
    reload () {
      this.$emit('reload') // should to emit to change parent components status
      this.myOptions = {}
    }
  },
  watch: {
    options () {
      this.myOptions = this.options
      this.barControl = ''
      this.timers.forEach((timer) => {
        window.clearTimeout(timer)
      })
      this.timers = []
      this.countdown()
    },
    show (val) {
      this.myOptions = this.options
      this.myShow = val
      if (val === true) {
        this.timers.forEach((timer) => {
          window.clearTimeout(timer)
        })
        this.timers = []
        this.countdown()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Notifications/Notification.vue?5556310d